<script lang="ts" setup>
import dayjs, { Dayjs } from 'dayjs';
import { computed } from 'vue';


type Props = {
    contractStartDate: string | Dayjs | undefined,
    isUsed: boolean
}

const { contractStartDate, isUsed } = defineProps<Props>();

const parsedContractStartDate = computed( () => contractStartDate ? dayjs( contractStartDate ) : null );
const showWarning = computed( () => isUsed && parsedContractStartDate.value && parsedContractStartDate.value.isAfter( dayjs() ) );

</script>

<template>

    <div class="text-warning" v-if="showWarning">
        Your car is still covered as part of the dealership's statutory warranty. Your PROTECT start date is {{ parsedContractStartDate!.format('MMMM D, YYYY') }}
    </div>

</template>